import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";
import Product from "@/server/com/silkplm/model/plm/Product";
import BudgetingPlanner from "@/server/com/silkplm/model/plm/BudgetingPlanner";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import OrderDetails from "@/server/com/silkplm/model/plm/OrderDetails";
import Tranche from "@/server/com/silkplm/model/plm/Tranche";
import MultiSelectToProductInSeason from "@/server/com/silkplm/model/plm/MultiSelectToProductInSeason";
import Role from "@/server/com/silkplm/model/users/Role";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import Delegation from "@/server/com/silkplm/model/plm/Delegation";
import ProductGrading from "@/server/com/silkplm/model/plm/dictionaries/ProductGrading";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import ChatMessageInquiry from "@/server/com/silkplm/model/plm/chat/ChatMessageInquiry";
import Inspiration from "@/server/com/silkplm/model/plm/Inspiration";
import Design from "@/server/com/silkplm/model/plm/Design";

export function getCustomizations() {
    return {
        lists: [
            {
                type: BookHealthcheck,
                activity: () => require('@/components/forms/customizations/healthchecks/BookHealthckeckList')
            },
            {
                type: BudgetingPlanner,
                activity: () => require('@/components/forms/customizations/plm/BudgetingPlannerList')
            },
            {
                type: BudgetingPlannerPM,
                activity: () => require('@/components/forms/customizations/plm/BudgetingPlannerListPM')
            },
            {
                type: OrderDetails,
                activity: () => require('@/components/forms/customizations/plm/OrderDetailsList')
            },
            // {
            //     type: Tranche,
            //     activity: () => require('@/components/forms/customizations/plm/TranchesList')
            // },
            {
                type: ApplicationUser,
                activity: () => require('@/components/forms/customizations/plm/DashboardUsers')
            },
            {
                type: ChatMessageBase,
                activity: () => require('@/components/forms/renderers/Chat.vue')
            },
            {
                type: ChatMessageInquiry,
                activity: () => require('@/components/forms/renderers/Chat.vue')
            },
        ],

        editors: [
            {
                type: BookHealthcheck,
                activity: () => require('@/components/forms/customizations/healthchecks/BookHealthckeckEditor')
            },
            {
                type: Product,
                activity: () => require('@/components/forms/customizations/plm/ProductsEditor')
            },
            {
                type: Inspiration,
                activity: () => require('@/components/forms/customizations/plm/InspirationEditor')
            },
            {
                type: OrderDetails,
                activity: () => require('@/components/forms/customizations/plm/OrderDetailsEditor')
            },
            {
                type: Tranche,
                activity: () => require('@/components/forms/customizations/plm/TrancheEditor')
            },
            {
                type: BudgetingPlannerPM,
                activity: () => require('@/components/forms/customizations/plm/BudgetingPlannerPMEditor')
            },
            {
                type: ProductGrading,
                activity: () => require('@/components/forms/customizations/plm/ProductGradingEditor')
            },
            {
                type: MultiSelectToProductInSeason,
                activity: () => require('@/components/forms/customizations/plm/MultiSelectToProductInSeasonEditor')
            },
            {
                type: Role,
                activity: () => require('@/components/forms/customizations/plm/RolesEditor')
            },
            {
                type: ApplicationUser,
                activity: () => require('@/components/forms/customizations/plm/UserEditPanel')
            },
            {
                type: Delegation,
                activity: () => require('@/components/forms/customizations/plm/DelegationEditor')
            },
        ]
    };
}